<template>
  <div>
    <section class="content-header">
      <h1>Top Gains</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Reports</a>
        </li>
        <li class="breadcrumb-item active">Top Gains</li>
      </ol>
    </section>

    <section class="content">
      <div class="box bg-hexagons-white">
        <div class="box-body">
          <div class="row">
            <div class="col-md-4 col-6">
              <div class="text-center">
                <h2 class="text-bold" @click="animation()">
                  <span class="count">{{ this.stats.direct }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Direct</h5>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="text-center">
                <h2 class="text-bold">
                  <span class="count">{{ this.stats.incentive }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Pasive</h5>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="text-center">
                <h2 class="text-bold">
                  <span class="count">{{ this.stats.binary }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Binary</h5>
              </div>
            </div>

            <div class="col-md-6 col-6">
              <div class="text-center">
                <h2 class="text-bold">
                  <span class="count">{{ this.stats.residual }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Residual</h5>
              </div>
            </div>

            <div class="col-md-6 col-6">
              <div class="text-center">
                <h2 class="text-bold">
                  <span class="count">{{ this.stats.career }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Career</h5>
              </div>
            </div>

            <!-- <div class="col-md-6 col-6">
              <div class="text-center">
                <h2 class="text-bold">
                  <span class="count">{{ this.stats.market_club }}</span>
                  USD
                </h2>
                <hr class="w-50 my-5 b-3 border-warning" />
                <h5 class="mt-10">Total Market Club</h5>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="row mt-20">
        <div class="col-12">
          <div class="box box-solid bg-dark">
            <div class="box-header with-border">
              <h3 class="box-title">Profit Details</h3>

              <div class="box-tools pull-right">
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-box-tool"
                  data-widget="remove"
                  data-toggle="tooltip"
                  title="Remove"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-bordered no-margin">
                  <thead>
                    <tr class="bg-dark">
                      <th class="text-white text-left">ID</th>
                      <th class="text-white text-center">Value</th>
                      <th class="text-white text-center">Type</th>
                      <th class="text-white text-center">Status</th>
                      <th class="text-white text-right">Trough</th>
                      <th class="text-white text-right">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="reward in tableData" :key="reward.id">
                      <td class="text-left">{{ reward.id }}</td>
                      <td>
                        <span class="text-white h6"
                          >{{ reward.value }} {{ reward.currency.name }}</span
                        >
                      </td>

                      <td class="text-center">
                        <span
                          class="badge badge-lg"
                          :class="
                            (reward.reward_type === 'incentive' &&
                              'badge-dark') ||
                              (reward.reward_type === 'direct' &&
                                'badge-dark') ||
                              (reward.reward_type === 'binary' &&
                                'badge-dark') ||
                              (reward.reward_type === 'market_club' &&
                                'badge-dark') ||
                              (reward.reward_type === 'residual' &&
                                'badge-dark') ||
                              (reward.reward_type === 'career' && 'badge-dark')
                          "
                        >
                          {{
                            (reward.reward_type === "incentive" && "daily") ||
                              (reward.reward_type === "direct" && "direct") ||
                              (reward.reward_type === "market_club" &&
                                "market_club") ||
                              (reward.reward_type === "binary" && "binary") ||
                              (reward.reward_type === "residual" &&
                                "residual") ||
                              (reward.reward_type === "career" && "career")
                          }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge badge-lg"
                          :class="
                            (reward.reward_status === 'pending' &&
                              'badge-pink') ||
                              (reward.reward_status === 'paid' &&
                                'badge-success') ||
                              (reward.reward_status === 'cancelled' &&
                                'badge-danger')
                          "
                        >
                          {{
                            (reward.reward_status === "pending" &&
                              "Unconfirmed") ||
                              (reward.reward_status === "paid" &&
                                "Confirmed") ||
                              (reward.reward_status === "cancelled" &&
                                "Canceled")
                          }}
                        </span>
                      </td>

                      <td class="text-right">
                        <span
                          class="badge badge-danger badge-lg"
                          v-if="reward.referred_user"
                          >{{ reward.referred_user }}</span
                        >
                        <span
                          class="badge badge-danger badge-lg"
                          v-if="
                            reward.reward_type === 'binary' &&
                              reward.redeemed_binary_points > 0
                          "
                          >{{ reward.redeemed_binary_points }} Binary
                          Points</span
                        >
                        <span
                          class="badge badge-danger badge-lg"
                          v-if="reward.reward_type === 'incentive'"
                          >{{ reward.subscription.plan.name }}
                        </span>
                      </td>

                      <td class="text-right">
                        <time>{{
                          reward.created_at | formatDate("MMMM Do YYYY hh:mm A")
                        }}</time>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
let $ = window.$;
import { formatDollar, formatDate } from "@/filters";

export default {
  name: "reports",
  props: {
    title: String
  },
  filters: { formatDollar, formatDate },
  data() {
    return {
      type: "",
      loading: false,
      tableData: [],
      stats: {
        incentive: 0.0,
        residual: 0.0,
        direct: 0.0,
        binary: 0.0,
        career: 0.0,
        market_club: 0.0
      },
      per_page: 25,
      page: 1,
      counter: 0,
      noResults: false
    };
  },
  watch: {
    counter: function(newValue) {
      if (newValue === 4) this.animation();
    }
  },
  mounted() {
    this.scroll();
  },
  created() {
    this.last_subs = this.$store.getters.currentUser.last_subs;
    this.getData(
      "incentive,binary,direct,residual,market_club,career",
      false,
      this.per_page,
      this.page
    );
    this.getData("market_club", true);
    this.getData("incentive", true);
    this.getData("direct", true);
    this.getData("binary", true);
    this.getData("residual", true);
    this.getData("career", true);
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow && !this.noResults) {
          this.getData(
            "incentive,binary,direct,residual,market_club,career",
            false,
            this.per_page,
            this.page + 1
          );
          this.page += 1;
        }
      };
    },
    animation() {
      setTimeout(() => {
        $(".count").each(function() {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).text()
              },
              {
                duration: 4000,
                easing: "swing",
                step: function(now) {
                  $(this).text(parseFloat(now).toFixed(2));
                }
              }
            );
        });
      }, 500);
    },
    getData(type, total, per_page, page) {
      this.loading = true;
      this.$http({
        url:
          "/api/v1/client/rewards?type=" +
          type +
          "&per_page=" +
          per_page +
          "&page=" +
          page +
          "&total=" +
          total,
        method: "get",
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken
        }
      })
        .then((response) => {
          this.loading = false;
          if (total) {
            this.stats[type] = parseFloat(response.data);
            this.counter += 1;
          } else {
            response.data.map((item) => {
              this.tableData.push(item);
            });
            if (response.data.length === 0) this.noResults = true;
          }
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true
              });
            });
          this.loading = false;
        });
    }
  }
};
</script>
